// Feature: daily cycle - request, pre-issue, validation, gas test, toolbox talk,
// acceptance (owner: cycle work package).
// Contract: export cycleActionPanels, CyclesView.
import type { ActionPanelMap } from '@/features/contracts'
import { AcceptCyclePanel } from './panels/AcceptCyclePanel'
import { GasTestPanel } from './panels/GasTestPanel'
import { PreissueCyclePanel } from './panels/PreissueCyclePanel'
import { RequestCyclePanel } from './panels/RequestCyclePanel'
import { TbtAttendancePanel } from './panels/TbtAttendancePanel'
import { ToolboxTalkPanel } from './panels/ToolboxTalkPanel'
import { ValidateCyclePanel } from './panels/ValidateCyclePanel'

export { CyclesView } from './CyclesView'

export const cycleActionPanels: ActionPanelMap = {
  request_cycle: RequestCyclePanel,
  preissue_cycle: PreissueCyclePanel,
  validate_cycle: ValidateCyclePanel,
  record_gas_test: GasTestPanel,
  record_toolbox_talk: ToolboxTalkPanel,
  sign_tbt_attendance: TbtAttendancePanel,
  accept_cycle: AcceptCyclePanel,
}
